<template>
    <div >
        <div class="container-fluid">
            <div class="container-width">

                <div class="row without_sliders no-gutters">
                    <div class="col-lg-8 col-md-8 col-sm-12 pl-0 pr-0 view-card" itemscope itemtype="https://schema.org/NewsArticle">
                        <a class="view-9apuap">
                            <div class="view-9apuap__image-block">
                                <img :src="image" class="card-img" ref="img" itemprop="image" crossorigin="">
                            </div>
                            <h5 class="view-9apuap__headline" itemprop="name">{{title}}</h5>
                        </a>
                        <div class="card-des" id="news"  v-html="text" itemprop="description"></div>
                        <div id="scripts"></div><div id="scripts-news"></div>

                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-12 pl-0 pr-0 ">
                        <div class="row row-sticky without_sliders no-gutters" v-if="isTable()">
                            <teaser4 style-class="col-lg-12 col-md-12 col-sm-12 d-flex teasers teaser4" :teaser="getTeaser(0)" :position="1"></teaser4>
                            <teaser4 style-class="col-lg-12 col-md-12 col-sm-12 d-flex teasers teaser4" :teaser="getTeaser(1)" :position="2"></teaser4>
                            <teaser4 style-class="col-lg-12 col-md-12 col-sm-12 d-flex teasers teaser4" :teaser="getTeaser(2)" :position="3"></teaser4>
                            <teaser4 style-class="col-lg-12 col-md-12 col-sm-12 d-flex teasers teaser4" :teaser="getTeaser(3)" :position="4"></teaser4>
                        </div>

                        <div class="row row-sticky without_sliders no-gutters" v-if="!isTable()">
                            <teaser4  style-class="col-lg-12 col-md-12 col-sm-12 d-flex teasers teaser4" :teaser="getTeaser(0)" :position="1"></teaser4>
                            <teaser4 style-class="col-lg-12 col-md-12 col-sm-12 d-flex teasers teaser4" :teaser="getTeaser(1)" :position="2"></teaser4>
                            <teaser4 v-if="teasers.length >= 3" style-class="col-lg-12 col-md-12 col-sm-12 d-flex teasers teaser4" :teaser="getTeaser(2)" :position="3"></teaser4>
                        </div>
                    </div>
                </div>

<!--                 <div class="teasers-for-article">
                    <teaser style-class="col-lg-12 col-md-12 col-sm-12 d-flex forArticle" v-for="(list, index) in teasersInArticle" :teaser="list" :position="index"></teaser>
    			</div> -->

                <div class="teasers-for-article">
                   
                    <teaser4 v-for='i in countTeaserInText' :key='i' :style-class="`tit_${i} teaser4`" :teaser="teasers2[i-1]"></teaser4>                    
    			</div>


                <infinite :offset="teaserOffset" v-if="teaserOffset > 0"></infinite>

<!--                 <infinite :offset="0" v-if="infiniti1 == 1"></infinite> -->
<!--                 <infinite :offset="teaserOffset" v-if="infiniti1 == 0"></infinite> -->



            </div>
            <pixel></pixel>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    // import teaser from '@/components/teaser.vue'
    import teaserGroup from '@/components/teaser-group.vue'
    import infinite from '@/components/infinite-preview2.vue'
    import pixel from '../components/pixel'


    import Teaser from '../components/teaser'
    import Teaser4 from '../components/teaser4'
    import Teaser2 from '../components/teaser2'
    import FastAverageColor from 'fast-average-color';

    export default {

        data(){
            return {
                image : '',
                title : '',
                text : '',
                rubric_id : 0,
                teasers:[],
                teasers2:[],
                teasersInArticle:[],
                teaserOffset:0,
                infiniti1:0,
                paragraphs:0,
                yandexBlocks:[],
                yandex_rtb_26:0,
                yandex_rtb_27:0,
                yandex_rtb_28:0,
                yandex_rtb_29:0,
                yandex_rtb_30:0,
                yandex_rtb_31:0,
                notLoadedYaTeasers:[],
                quantity: '',
				countTeaserInText:0,
                gradientStyle:{},
                style:{},
                size: 50,
                amount:3,
                multiItemSlider:null
            };
        },
        components: {
            // teaser,
            teaserGroup,
            infinite,
            pixel,
            Teaser,
            Teaser2,
            Teaser4,


        },
        mounted() {
			ym(94590406, 'reachGoal', 'view2');

            let img = this.$refs.img;
            img.crossorigin = 'anonymous';
            let vue = this;
            img.addEventListener('load', function()
            {
                let fac = new FastAverageColor();
                let height = this.naturalHeight;

                let color = fac.getColor(this, {top: height - vue.size, height: vue.size});

                var colorEnd = [].concat(color.value.slice(0, 3), 0).join(',');
                vue.style = {
                    background: color.rgb,
                    color:      color.isDark ? 'white' : 'black',
                };

                vue.gradientStyle  = {background: 'linear-gradient(to bottom, ' +
                        'rgba(' + colorEnd + ') 0%, ' + color.rgba + ' 100%)'};

                window.addEventListener("scroll", function(){
                    try {
                    	if (window.scrollY > +document.querySelector(".card-des").offsetHeight - 1000) vue.infiniti1 = 1;
                    } catch (r) { }
                });
            }, false);

            this.Helper.getArticle(this.$route.query.utm_content, this.$route.query)
                .onSuccess((response)=>{
                console.log("getArticle view");               	


                    this.title = response.data.title;
                    this.image = response.data.image_rectangle;
                    this.text = response.data.text;
                    this.rubric_id = response.data.rubric_id;
                    this.text = this.text.replace(/<[^<>]+>\&nbsp\;\<\/p\>/g, "");                

                	
                    let paragraphsArray = this.text.split("</p>");
                	let trash = paragraphsArray.pop();
                	paragraphsArray = paragraphsArray.map(function(s) {
                       	return s + "</p>";
					console.log(paragraphsArray);
//                     let countSymbols = 150;
                	let quantity = this.Helper.query["quantity"];
//                 	 console.log("countSymbols", countSymbols);                   
                    });
                

//                 	if (!!quantity) {
//                         countSymbols = quantity
//                     }
                	let countSymbols = 0;
                
                
                    for (let i = 0; i < paragraphsArray.length; i++) {
                        
                        if (paragraphsArray[i] == null) break;
                        if (paragraphsArray[i + 1] == null) break;
                         if (paragraphsArray[i].search(/<img.+?>/g) !== -1) continue;
                        
                        if (paragraphsArray[i].length + countSymbols < 150) {
                            countSymbols += paragraphsArray[i].length
                            continue;
                        }
                        countSymbols = 0;                        

                        this.countTeaserInText++
                        paragraphsArray[i] += '<div id="tit_' + this.countTeaserInText + '" class="teaser-makros"></div>';                        
                    }
                
                
                
                
               
                

                    this.text = paragraphsArray.join(" ");
                
                	if (paragraphsArray.length === 0) {
                        this.text = response.data.text;
                    }

                    let amount = (this.isTable()) ? 4 : 3;
// 					amount += this.countTeaserInText;
                
                    this.Helper.getTeasers(this, amount, this.teaserOffset, 1,0,  {quality:1})
                		.onSuccess((response)=>{                            
                    		this.teasers = response.data;
                    		this.teaserOffset = response.data.length;
                        console.log("countTeaserInText", this.countTeaserInText);
                        
                        this.Helper.getTeasers(this, this.countTeaserInText, 100, 1,0,  {quality:1})
                		.onSuccess((response2)=>{     
                    		this.teasers2 = response2.data;  
          
                              setTimeout(() => { 
                         for (let i=1; i<= this.countTeaserInText; i++) {
                                console.log(".tit_" + i);
                                let teaser = document.querySelector(".tit_" + i);
    									let teserPosition = document.querySelector("#tit_" + i);

        							    teserPosition.append(teaser);
                            }
                            }, 100)

                        	
                        
                		})
                		.onFail((error)=>{
                    		console.log(error)
                		})
                        	
                        
                		})
                		.onFail((error)=>{
                    		console.log(error)
                		})

                	console.log("-------------------------------------------- / --------------------------------------------");
                    console.log(this.text);
                	console.log(this.paragraphs);
                	console.log("-------------------------------------------- / --------------------------------------------");
                })
                .onFail((error)=>{
                    console.log(error)
                });




        },
        methods: {
            getTeasers (amount) {
                return this.Helper.getManyTeaser(this.teasers, amount);
            },

              getTeaser (index) {
                if (index === undefined) return this.Helper.getOneTeaser(this.teasers);
                if (!this.teasers[index]) return {};
                return this.teasers[index];
                
            },               

        }
    }
</script>


<style scoped>

</style>